import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addButton", "form", "urlInput", "titleInput", "formElement"]

  showForm() {
    this.formTarget.classList.remove("hidden")
    this.addButtonTarget.classList.add("hidden")
    this.urlInputTarget.focus()
  }

  hideForm() {
    this.formTarget.classList.add("hidden")
    this.addButtonTarget.classList.remove("hidden")
  }

  submitForm(event) {
    event.preventDefault()
    this.formElementTarget.requestSubmit()
    this.urlInputTarget.value = ""
    this.titleInputTarget.value = ""
    this.urlInputTarget.focus()
  }
}
